import { render, staticRenderFns } from "./AlertNotification.vue?vue&type=template&id=1b5fdab5&scoped=true&"
import script from "./AlertNotification.vue?vue&type=script&lang=js&"
export * from "./AlertNotification.vue?vue&type=script&lang=js&"
import style0 from "./AlertNotification.vue?vue&type=style&index=0&id=1b5fdab5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5fdab5",
  null
  
)

export default component.exports